import type { TFunction } from 'i18next';
import * as yup from 'yup';

export const validationSchema = (t: TFunction) =>
  yup.object({
    callHappened: yup.boolean(),
    firstContactAt: yup
      .date()
      .required(t('validationError.dateRequired'))
      .max(new Date(), t('validationError.dateInFuture')),
    rootCauses: yup
      .array()
      .of(yup.number())
      .max(5, t('validationError.rootCausesMaxFive')),
    npsGroup: yup.string(),
    customFields: yup.array().of(
      yup.object({
        id: yup.number(),
        value: yup.string().when('required', {
          is: true,
          then: (schema) => schema.required('required'),
          otherwise: (schema) => schema.optional(),
        }),
        required: yup.boolean().default(false),
      }),
    ),
  });
